import { ProgramModule_mkProgram, ProgramModule_run } from "../Server/.fable/Fable.Elmish.3.1.0/program.fs.js";
import { Program_withReactSynchronous } from "../Server/.fable/Fable.Elmish.React.3.0.1/react.fs.js";
import { view, update, init } from "./App.fs.js";

ProgramModule_run(Program_withReactSynchronous("elmish-app", ProgramModule_mkProgram(init, (msg, state) => update(msg, state), (state_1, dispatch) => view(state_1, dispatch))));

